import React from 'react';
import { Link } from 'react-router-dom';
import ErrorLayout from '../components/ErrorLayout';

const Error500 = () => {
  return (
    <ErrorLayout
      code={500}
      title="Internal Server Error"
      message="Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar dene."
      action={<Link to="/" className="px-4 py-2 rounded-lg text-white" style={{ backgroundColor: '#1E40AF' }}>Ana sayfaya dön</Link>}
    />
  );
};

export default Error500;


